import * as types from "./actionTypes";
import * as usersApi from "../../api/usersApi";
import * as authApi from "../../api/authApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function receiveUpdateGeneralSettings(settings) {
    return { type: types.UPDATE_SETTINGS_GENERAL_SUCCESS, settings}
}

export function receiveUpdateSiteSettings(settings) {
    return { type: types.UPDATE_SETTINGS_SITE_SUCCESS, settings}
}

export function receiveUpdatePasswordSettings(settings) {
    return { type: types.UPDATE_SETTINGS_PASSWORD_SUCCESS, settings}
}

export function receiveUpdateAvatarSettings(settings) {
    return {
        type: types.UPDATE_SETTINGS_AVATAR_SUCCESS, settings
    }
}

export function avatarVersionUpdated(version) {
    return {
        type: types.UPDATE_AVATAR_VERSION, version
    }
}

export function receiveUpdateBannerSettings(settings) {
    return {
        type: types.UPDATE_SETTINGS_BANNER_SUCCESS, settings
    }
}

export function bannerVersionUpdated(version) {
    return {
        type: types.UPDATE_BANNER_VERSION, version
    }
}

export function receiveUpdateUserDetails(details) {
    return {
        type: types.UPDATE_USER_DETAILS, details
    }
}

export function receiveUpdateUserPreferredMeasurementUnits(units) {
    return {
        type: types.UPDATE_USER_PREFERREDMEASUREMENTS, units
    }
}

export function accountClosed() {
    return {
        type: types.LOGOUT_SUCCESS
    }
}

export function updateGeneralSettings(settings) {

    return dispatch => {

        //dispatch(beginApiCall()); 

        return usersApi.updateGeneralSettings(settings)
            .then(() => {
                dispatch(receiveUpdateGeneralSettings(settings));
                dispatch(receiveUpdateUserDetails({
                    firstName: settings.firstName,
                    surname: settings.surname
                }))
                return settings;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function updateSiteSettings(settings) {

    return dispatch => {

        //dispatch(beginApiCall()); 

        return usersApi.updateSiteSettings(settings)
            .then(() => {
                dispatch(receiveUpdateSiteSettings(settings));
                dispatch(receiveUpdateUserPreferredMeasurementUnits(settings.preferredMeasurementUnits == 0 ? "Metric" : "Statute"))
                return settings;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}


export function uploadAvatar(settings) {
     return dispatch => {
        var avatar = settings.avatarDetails
        return usersApi.uploadAvatar(avatar)
            .then(() => {
                dispatch(receiveUpdateAvatarSettings(settings));
                dispatch(avatarVersionUpdated(settings.avatarDetails.version));
                return avatar;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function uploadBanner(settings) {
    return dispatch => {
        var banner = settings.banner
        return usersApi.uploadBanner(banner)
            .then(() => {
                dispatch(receiveUpdateBannerSettings(settings));
                dispatch(bannerVersionUpdated(settings.banner.version));
                return banner;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}

export function closeAccount(userId) {
    return dispatch => {
        return usersApi.deleteUser(userId)
            .then((result) => {
                
                return result;
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}






// WEBPACK FOOTER //
// ./src/redux/actions/settingsActions.js